<template>
  <div class="library-share">
    <iframe
      :src="downloadUrl"
      width="100%"
      height="900"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "library-share",
  data() {
    return {
      downloadUrl: this.$route.query.url
    };
  }
};
</script>

<style lang="scss" scoped></style>
